/** Textos da seção Planos na landing (público). */

export const LANDING_PLANS_SECTION_BADGE = 'Planos';

export const LANDING_PLANS_SECTION_TITLE_LEAD = 'O mesmo RetornaAr.';

export const LANDING_PLANS_SECTION_TITLE_GRADIENT = 'Três períodos de cobrança.';

export const LANDING_PLANS_SECTION_SUBTITLE =
  'Mensal, semestral ou anual — você escolhe como prefere pagar. O sistema é o mesmo em todos os planos.';

/** Bloco informativo após os valores (antes do CTA final). */
export const LANDING_PLANS_TRIAL_TITLE = '7 dias grátis para testar';

export const LANDING_PLANS_TRIAL_BODY =
  'Por 7 dias você usa o sistema completo: cadastros, lembretes no seu WhatsApp e agenda de manutenções. Teste na prática; em seguida, se fizer sentido, escolhe mensal, semestral ou anual.';

/** CTA no final da seção de planos (após o bloco de teste). */
export const LANDING_PLANS_AFTER_GRID_CTA_LABEL = 'Quero recuperar meus clientes';
